<dl class="row mb-0">
    @if (permit.applicant) {
        <dt class="col-sm-4">Applicant</dt>
        <dd class="col-sm-8">
            {{ permit.applicant.firstName }} {{ permit.applicant.lastName }}
            <div class="text-muted small">
                {{ permit.applicant.email }}
                @if (permit.applicant.phone) {
                    · {{ permit.applicant.phone }}
                }
                @if (permit.applicant.dob) {
                    · DOB {{ permit.applicant.dob | date: 'd MMM y' }}
                }
            </div>
        </dd>
    }

    @if (permit.applicantAddress) {
        <dt class="col-sm-4">Address</dt>
        <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.applicantAddress }}</dd>
    }

    <!-- Only the Long-term Resident permit carries a residential address, so the row
         shows only when present. LTR has no dedicated detail component - it falls through
         to this shared one - so without this the applicant's own address was editable but
         never shown read-only. -->
    @if (permit.residentialAddress) {
        <dt class="col-sm-4">Residential address</dt>
        <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.residentialAddress }}</dd>
    }

    <!-- Holder photo (TLC, 30 Sep): only the annual fishing/hunting and LTR permits
         carry one, so the row shows only when it is present. -->
    @if (permit.applicantPhoto) {
        <dt class="col-sm-4">Holder photo</dt>
        <dd class="col-sm-8">
            @if (isImage(permit.applicantPhoto)) {
                <a [href]="documentUrl(permit.applicantPhoto)" target="_blank" rel="noopener" class="d-inline-block">
                    <img
                        [src]="documentUrl(permit.applicantPhoto)"
                        [alt]="permit.applicantPhoto.filename || 'Holder photo'"
                        class="uploaded-photo rounded border"
                        loading="lazy"
                    />
                </a>
                <div class="small text-muted mt-1">{{ permit.applicantPhoto.filename }}</div>
            } @else {
                <a [href]="documentUrl(permit.applicantPhoto)" target="_blank" rel="noopener">
                    <i class="fa fa-file me-1"></i>{{ permit.applicantPhoto.filename || 'View photo' }}
                </a>
            }
        </dd>
    }

    <!-- A permit can cover a party or a research team. Staff assessing one, and an
         applicant checking their own, both need to see who is on it - not just how many. -->
    @if (permit.partySize && permit.partySize > 1) {
        <dt class="col-sm-4">{{ membersLabel }}</dt>
        <dd class="col-sm-8">
            {{ permit.partySize }} people
            @if (permit.members?.length) {
                @for (member of permit.members; track $index) {
                    <div class="text-muted small">
                        {{ ((member.firstName || '') + ' ' + (member.lastName || '')).trim() || member.name }}
                        @if (member.dob) {
                            <span> · {{ member.dob | date: 'd MMM y' }}</span>
                        }
                    </div>
                }
            } @else {
                <div class="text-muted small">{{ permit.partyNames?.join(', ') }}</div>
            }
        </dd>
    }

    <dt class="col-sm-4">Dates</dt>
    <dd class="col-sm-8">
        @if (permit.accessStartDate) {
            {{ permit.accessStartDate }} → {{ permit.accessEndDate }}
        } @else {
            -
        }
    </dd>

    @if (showLocation) {
        <dt class="col-sm-4">{{ locationCount > 1 ? 'Locations' : 'Location' }}</dt>
        <dd class="col-sm-8">
            @if (locationCount > 1) {
                <!-- One per line rather than a comma run: staff scan this to see whether a
             place they care about is on the permit, and three names in a row reads
             as one string. -->
                <ul class="list-unstyled mb-0">
                    @for (loc of permit.locations; track loc.id) {
                        <li>{{ loc.name }}</li>
                    }
                    @if (permit.locationOther) {
                        <li>{{ permit.locationOther }} <span class="text-muted small">(not on the list)</span></li>
                    }
                </ul>
            } @else {
                {{ permit.location || '-' }}
            }
        </dd>
    }

    @if (permit.business) {
        <dt class="col-sm-4">Issued by</dt>
        <dd class="col-sm-8">{{ permit.business }}</dd>
    }

    @if (permit.purpose) {
        <dt class="col-sm-4">Purpose</dt>
        <dd class="col-sm-8" style="white-space: pre-wrap">{{ permit.purpose }}</dd>
    }

    <!-- Only the assessed types ask this (Work, Media, Research, Friends & Family); it's
         null on the others, so the row is shown only where the question was put. -->
    @if (permit.travellingOutsideLocations != null) {
        <dt class="col-sm-4">Travelling outside selected locations</dt>
        <dd class="col-sm-8">{{ permit.travellingOutsideLocations ? 'Yes' : 'No' }}</dd>
    }
</dl>
